import { DrugDetails } from './drug-details';
import { DrugSearchPATabAndOtherTabDetails } from './drug-search-patab-and-other-tab-details';
import { DrugSearchQLTabDetails } from './drug-search-qltab-details';
import { DrugSearchSTTabDetails } from './drug-search-sttab-details';
import { ValidMatchingEntry } from './valid-matching-entry';

export class DrugSearchDetailData {

  drugSearchMatchingEntry: ValidMatchingEntry;

  drugDetails: DrugDetails;
  flTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  stTabDetails: Array<DrugSearchSTTabDetails>;
  qlTabDetails: Array<DrugSearchQLTabDetails>;
  paTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;

  acaTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  ageTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  bhrsTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  code1TabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  dlTabDetails :  Array<DrugSearchPATabAndOtherTabDetails>;
  exdTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  fffTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  fabTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  gapTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  genderTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  hcTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  hiTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  ispTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  laTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  laoTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  moTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  maintanaceTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  mabTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  npdTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  ndsTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  oacTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  otherTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  otcTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  partbTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  pgTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  pdTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  pdcTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  rebateTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  saoTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  spTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  vbidTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  siTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  partdTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
  zdvTabDetails: Array<DrugSearchPATabAndOtherTabDetails>;
}
